import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Facebook, Youtube, Mail, Phone, MapPin } from "lucide-react";
import { QDMonogram } from "./Header";

export default function SiteFooter({ settings }) {
  const s = settings || {};
  return (
    <footer data-testid="site-footer" className="bg-[#1A1A1A] text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <QDMonogram size={56} />
              <div>
                <p className="font-serif-display text-2xl tracking-[0.18em] uppercase">Queens</p>
                <p className="font-serif-display italic text-xl tracking-[0.18em] uppercase text-white/60">Daily</p>
              </div>
            </div>
            <h2 className="font-serif-display text-4xl sm:text-5xl leading-[0.95] tracking-tight">
              Stories for the
              <br />
              <span className="italic font-light">brave.</span>
            </h2>
            <p className="mt-6 font-sans-modern text-base text-white/70 leading-relaxed max-w-md">
              {s.about || "An editorial home for stories that matter — shaped by and for women."}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-white/50 mb-4">The Magazine</p>
            <ul className="space-y-2.5 font-sans-modern text-base">
              <li><Link to="/about" data-testid="footer-about-link" className="text-white/85 hover:text-white hover:underline underline-offset-4">About Us</Link></li>
              <li><Link to="/advertise" data-testid="footer-advertise-link" className="text-white/85 hover:text-white hover:underline underline-offset-4">Advertise with Us</Link></li>
              <li><Link to="/contact" data-testid="footer-contact-link" className="text-white/85 hover:text-white hover:underline underline-offset-4">Contact</Link></li>
              <li><Link to="/admin/login" data-testid="footer-admin-link" className="text-sm text-white/55 hover:text-white">Admin Portal</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline text-white/50 mb-4">Get in touch</p>
            <ul className="space-y-3 font-sans-modern text-sm text-white/85">
              {s.contact_email && (
                <li className="flex items-center gap-2.5">
                  <Mail size={14} strokeWidth={1.5} />
                  <a href={`mailto:${s.contact_email}`} className="hover:underline underline-offset-4">{s.contact_email}</a>
                </li>
              )}
              {s.contact_phone && (
                <li className="flex items-center gap-2.5">
                  <Phone size={14} strokeWidth={1.5} />
                  <span>{s.contact_phone}</span>
                </li>
              )}
              {s.address && (
                <li className="flex items-start gap-2.5">
                  <MapPin size={14} strokeWidth={1.5} className="mt-0.5" />
                  <span>{s.address}</span>
                </li>
              )}
            </ul>

            <p className="overline text-white/50 mt-8 mb-4">Follow</p>
            <div className="flex items-center gap-3">
              {s.instagram && (
                <a href={s.instagram} target="_blank" rel="noreferrer" aria-label="Instagram"
                   className="w-10 h-10 rounded-full border border-white/25 flex items-center justify-center hover:bg-white hover:text-[#1A1A1A] hover:border-white transition-colors">
                  <Instagram size={16} strokeWidth={1.5} />
                </a>
              )}
              {s.twitter && (
                <a href={s.twitter} target="_blank" rel="noreferrer" aria-label="Twitter"
                   className="w-10 h-10 rounded-full border border-white/25 flex items-center justify-center hover:bg-white hover:text-[#1A1A1A] hover:border-white transition-colors">
                  <Twitter size={16} strokeWidth={1.5} />
                </a>
              )}
              {s.facebook && (
                <a href={s.facebook} target="_blank" rel="noreferrer" aria-label="Facebook"
                   className="w-10 h-10 rounded-full border border-white/25 flex items-center justify-center hover:bg-white hover:text-[#1A1A1A] hover:border-white transition-colors">
                  <Facebook size={16} strokeWidth={1.5} />
                </a>
              )}
              {s.youtube && (
                <a href={s.youtube} target="_blank" rel="noreferrer" aria-label="YouTube"
                   className="w-10 h-10 rounded-full border border-white/25 flex items-center justify-center hover:bg-white hover:text-[#1A1A1A] hover:border-white transition-colors">
                  <Youtube size={16} strokeWidth={1.5} />
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/55">
          <span>© {new Date().getFullYear()} Queens Daily. All rights reserved.</span>
          <Link to="/" className="overline hover:text-white">Back to the deck</Link>
        </div>
      </div>
    </footer>
  );
}
